import authSignup from './library/auth-signup';
import authVerifyToken from './library/auth-verify-token';
import authSignin from './library/auth-signin';
import authLogout from './library/auth-logout';
import authForgotpassword from './library/auth-forgot-password';

// Signup
const modAuthSignup = new authSignup(
    '#wrap_auth_signup',
    '#auth_signup',
    'alert_signup_auth_form',
    'btn_auth_signup',
);
modAuthSignup.initForm();

// Verify token
const modAuthVerifyToken = new authVerifyToken('#auth_box_activate');
modAuthVerifyToken.checkToken();

// Signin
const modAuthSignin = new authSignin(
    '#auth_signin',
    'alert_signin_auth_form',
    'btn_auth_signin'
);
modAuthSignin.initForm();

// Logout
const modAuthLogout = new authLogout('#btn_auth_logout');
modAuthLogout.logout();

// Forgot password
const modAuthForgotPassword = new authForgotpassword(
    '#wrap_auth_forgot_password',
    '#auth_forgot_password',
    'alert_forgot_password_auth_form',
    '#btn_auth_forgot_password',
    '#auth_code_forgot_password',
    '#btn_auth_code_forgot_password'
);
modAuthForgotPassword.initForm();